import { combineReducers } from "redux"
import * as actionTypes from "./actionTypes"
import {
  UserId, UserIdState, UserIdAction,
  LocationState, LocationAction,
  Layer, LayersState, LayersAction,
  BaseLayer, BaseLayersState, BaseLayersAction,
  FilterActiveState, FilterActiveAction,
  MapOpenedState, MapOpenedAction,
  DrawEnabledState, DrawEnabledAction,
  ContactOpenedState, ContactOpenedAction,
  ObjectClickState, ObjectClickAction
} from "./type";


const initialStateUser: UserIdState = {
  user: undefined
}
const reducerUser = (
  state: UserIdState = initialStateUser,
  action: UserIdAction
): UserIdState => {
  switch (action.type) {
    case actionTypes.GET_USERID:
      let newId: UserId | null | undefined
      newId = action.user
      return {
        ...state,
        user: newId,
      }
  }

  return state
}

const initialStatelocation: LocationState = {
  location: undefined
}
const reducerLocation = (
  state: LocationState = initialStatelocation,
  action: LocationAction
): LocationState => {
  switch (action.type) {
    case actionTypes.SET_LOCATION:
      let location: string | null | undefined
      location = action.location
      return {
        ...state,
        location: location,
      }
  }
  return state
}


const initialStateLayers: LayersState = {
  layers: undefined
}
const reducerLayers = (
  state: LayersState = initialStateLayers,
  action: LayersAction
): LayersState => {
  let layers: Array<Layer> | null | undefined;
  switch (action.type) {
    case actionTypes.CHANGE_LAYERS:
      layers = action.layers
      return {
        ...state,
        layers: layers
      }
    case actionTypes.TURN_OFF_ALL_LAYERS:
      layers = state.layers;
      layers?.forEach((layer) => {
        layer.turned = false
      })
      return {
        ...state,
        layers: layers
      }
  }
  return state
}


const initialStateBaseLayers: BaseLayersState = {
  baseLayers: undefined
}
const reducerBaseLayers = (
  state: BaseLayersState = initialStateBaseLayers,
  action: BaseLayersAction
): BaseLayersState => {
  let baseLayers: Array<BaseLayer> | null | undefined;
  switch (action.type) {
    case actionTypes.CHANGE_BASE_LAYERS:
      baseLayers = action.baseLayers
      return {
        ...state,
        baseLayers: baseLayers
      }
  }
  return state
}

const initialStateFilterActive: FilterActiveState = {
  active: true
}
const reducerFilterActive = (
  state: FilterActiveState = initialStateFilterActive,
  action: FilterActiveAction
): FilterActiveState => {
  switch (action.type) {
    case actionTypes.SET_FILTER_ACTIVE:
      return {
        active: action.active
      }
  }
  return state
}

const initialStateMapOpened: MapOpenedState = {
  opened: true,
  coords: null
}
const reducerMapOpened = (
  state: MapOpenedState = initialStateMapOpened,
  action: MapOpenedAction
): MapOpenedState => {
  switch (action.type) {
    case actionTypes.SET_MAP_OPENED:
      return {
        opened: action.opened,
        coords: action.coords
      }
  }
  return state
}

const initialStateDrawEnabled: DrawEnabledState = {
  enabled: false
}
const reducerDrawEnabled = (
  state: DrawEnabledState = initialStateDrawEnabled,
  action: DrawEnabledAction
): DrawEnabledState => {
  switch (action.type) {
    case actionTypes.SET_DRAW_ENABLED:
      return {
        enabled: action.enabled
      }
  }
  return state
}

const initialStateContactOpened: ContactOpenedState = {
  opened: false
}
const reducerContactOpened = (
  state: ContactOpenedState = initialStateContactOpened,
  action: ContactOpenedAction
): ContactOpenedState => {
  switch (action.type) {
    case actionTypes.SET_CONTACT_OPENED:
      return {
        opened: action.opened
      }
  }
  return state
}

const initialStateObjectClick: ObjectClickState = {
  feature: null
}
const reducerObjectClick = (
  state: ObjectClickState = initialStateObjectClick,
  action: ObjectClickAction
): ObjectClickState => {
  switch (action.type) {
    case actionTypes.SET_OBJECT_CLICK:
      return {
        feature: action.feature
      }
  }
  return state
}

const rootReducer = combineReducers({
  containerUser: reducerUser,
  containerLocation: reducerLocation,
  containerLayers: reducerLayers,
  containerBaseLayers: reducerBaseLayers,
  containerFilterActive: reducerFilterActive,
  containerMapOpened: reducerMapOpened,
  containerDrawEnabled: reducerDrawEnabled,
  containerContactOpened: reducerContactOpened,
  containerObjectClick: reducerObjectClick
})


export default rootReducer